export const omit = <T, U extends keyof T>(obj: T, keys: U[]): Omit<T, U> =>
  (Object.keys(obj) as U[]).reduce(
    (acc, curr) => (keys.includes(curr) ? acc : { ...acc, [curr]: obj[curr] }),
    {} as Omit<T, U>
  );

export const pick = <O, K extends keyof O>(obj: O, keys: K[]): Pick<O, K> =>
  Object.entries(obj).reduce((picked, [key, val]) => {
    return {
      ...picked,
      ...(keys.includes(key as K) && { [key]: val }),
    };
  }, {}) as Pick<O, K>;
